import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Optional,
  Output,
  Self,
  ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'sc-checkbox',
  styleUrls: ['./checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatCheckboxModule],
  template: `
    <mat-checkbox
      [disabled]="disabled"
      [checked]="value"
      [color]="color"
      class="sc-design-text-3"
      (change)="onClick($event.checked)"
    >
      <ng-content></ng-content>
    </mat-checkbox>
  `,
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() color: ThemePalette = 'primary';
  @Input() disabled = false;
  @Input() value = false;

  @Output() changeValue = new EventEmitter<boolean>();

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(
    @Self()
    @Optional()
    public ngControl: NgControl,
    public changeDetectorRef: ChangeDetectorRef
  ) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  writeValue(value: boolean): void {
    this.value = value;
    this.changeDetectorRef.detectChanges();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onClick(value) {
    if (this.disabled) return;
    this.value = value;

    this.onChange(this.value);
    this.changeValue.emit(this.value);
  }
}
